"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditCardService = void 0;
const Base_1 = require("../Base");
const apiRoutes_1 = require("../../utils/apiRoutes");
class CreditCardService extends Base_1.BaseService {
    constructor(serviceConfig = {}) {
        super(serviceConfig);
        this.baseURLForPCI = apiRoutes_1.pciOrigin;
        const { baseURLForPCI } = serviceConfig;
        if (baseURLForPCI) {
            this.baseURLForPCI = baseURLForPCI;
        }
    }
    fetchCreditCard(creditCardId) {
        return this.request({
            method: 'get',
            url: (0, apiRoutes_1.publicCreditCardUrl)(creditCardId),
        }).then((response) => response.creditCard);
    }
    fetchCreditCards(options = {}) {
        const { fullInfo = false, contactId } = options;
        const params = Object.assign(Object.assign({}, (fullInfo ? { fullInfo } : {})), (contactId ? { contactId } : {}));
        return this.request({
            method: 'get',
            url: (0, apiRoutes_1.publicCreditCardsUrl)(),
            params,
        }).then((response) => response.creditCards);
    }
    tokenizeCreditCard(data) {
        return this.request({
            baseURL: this.baseURLForPCI,
            method: 'post',
            url: (0, apiRoutes_1.tokenizeCardUrl)(),
            data,
        }).then((response) => response.token);
    }
    tokenizeSavedCreditCard(creditCardId, data) {
        return this.request({
            baseURL: this.baseURLForPCI,
            method: 'post',
            url: (0, apiRoutes_1.tokenForSavedCard)(creditCardId),
            data,
        }).then((response) => response.token);
    }
    saveCreditCard(creditCard) {
        return this.request({
            baseURL: this.baseURLForPCI,
            method: 'post',
            url: (0, apiRoutes_1.creditCardsUrl)(),
            data: { creditCard },
        }).then((response) => response.creditCard);
    }
    updateCreditCard(data) {
        return this.request({
            baseURL: this.baseURLForPCI,
            method: 'patch',
            url: (0, apiRoutes_1.creditCardUrl)(data.creditCardId),
            data: Object.assign({ creditCard: data.creditCard }, (data.fieldMask
                ? {
                    fieldMask: data.fieldMask,
                }
                : {})),
        }).then((response) => response.creditCard);
    }
    deleteCreditCard(creditCardId) {
        return this.request({
            method: 'delete',
            url: (0, apiRoutes_1.publicCreditCardUrl)(creditCardId),
        });
    }
    makeCreditCardPrimary(creditCardId) {
        return this.request({
            method: 'post',
            url: (0, apiRoutes_1.publicCreditCardPrimaryUrl)(creditCardId),
        });
    }
}
exports.CreditCardService = CreditCardService;
//# sourceMappingURL=index.js.map